"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _entriesTableRow = _interopRequireDefault(require("./entries-table-row"));
var _entriesTableHead = _interopRequireDefault(require("./entries-table-head"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function compareValues(a, b) {
  if (a === b) return 0;
  if (a > b || a === null) return 1;
  return -1;
}
function compareEntries(a, b, sortedColumnID) {
  switch (sortedColumnID) {
    case 'bibName':
    case 'startListBib':
    case 'entryText':
    case 'hasPaid':
    case 'isLateEntry':
    case 'isOnlineEntry':
    case 'entrySortDate':
    case 'freeCode':
      return compareValues(a[sortedColumnID], b[sortedColumnID]);
    case 'ageCategory':
    case 'entryType':
    case 'rankingDivision':
    case 'entryStatus':
      return compareValues(a[sortedColumnID].sortOrder, b[sortedColumnID].sortOrder);
    case 'day':
      return compareValues(a.race.competitionDay.dayDate, b.race.competitionDay.dayDate);
    case 'race':
      return compareValues(a.race.competitionDivision.divLevel, b.race.competitionDivision.divLevel) || compareValues(a.race.event.sortOrder, b.race.event.sortOrder) || compareValues(a.race.competitionDay.dayDate, b.race.competitionDay.dayDate);
    default:
      throw new Error('Unsupported column sort');
  }
}
class EntriesTable extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      sortedColumnID: null,
      sortedDirection: null
    });
    _defineProperty(this, "_onToggleSort", columnID => {
      if (this.state.sortedColumnID === columnID) {
        this.setState({
          sortedColumnID: columnID,
          sortedDirection: this.state.sortedDirection === 'ASC' ? 'DESC' : 'ASC'
        });
      } else {
        this.setState({
          sortedColumnID: columnID,
          sortedDirection: 'ASC'
        });
      }
    });
    _defineProperty(this, "_getSortedEntries", () => {
      if (this.state.sortedColumnID === null) {
        return this.props.entries;
      }
      if (!this._previousSortedEntries) {
        this._previousSortedEntries = this.props.entries;
      }
      // N.B. we slice the array to avoid modifying the original (unfortunately .sort modifies the original)
      const sortedEntries = this.props.entries.slice().sort((a, b) => {
        const order = compareEntries(a, b, this.state.sortedColumnID);
        if (order === 0) {
          return this._previousSortedEntries.indexOf(a) - this._previousSortedEntries.indexOf(b);
        }
        if (this.state.sortedDirection === 'DESC') return order * -1;
        return order;
      });
      this._previousSortedEntries = sortedEntries;
      return sortedEntries;
    });
  }
  render() {
    const entries = this._getSortedEntries();
    const extraColumnHeadings = this.props.renderExtraColumnHeadings && this.props.renderExtraColumnHeadings({
      sortedColumnID: this.state.sortedColumnID,
      sortedDirection: this.state.sortedDirection,
      onToggleSort: this._onToggleSort
    });
    return /*#__PURE__*/_react.default.createElement(_table.default, {
      hover: true
    }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement(_entriesTableHead.default, {
      sortedColumnID: this.state.sortedColumnID,
      sortedDirection: this.state.sortedDirection,
      useFreeCode: this.props.useFreeCode,
      onToggleSort: this._onToggleSort
    }, extraColumnHeadings)), /*#__PURE__*/_react.default.createElement("tbody", null, entries.map(entry => /*#__PURE__*/_react.default.createElement(_entriesTableRow.default, {
      key: entry.id,
      useFreeCode: this.props.useFreeCode,
      entry: entry
    }, this.props.renderExtraColumns && this.props.renderExtraColumns(entry)))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}
_defineProperty(EntriesTable, "partialQueries", {
  Entry: _mergeBqlQueries({
    id: true,
    ageCategory: {
      sortOrder: true
    },
    entryType: {
      sortOrder: true
    },
    rankingDivision: {
      sortOrder: true
    },
    entryStatus: {
      sortOrder: true
    },
    race: {
      event: {
        sortOrder: true
      },
      competitionDivision: {
        divLevel: true
      }
    }
  }, _entriesTableRow.default.partialQueries.Entry)
});
var _default = exports.default = EntriesTable;